import styled from "styled-components";
import { flexbox, layout, position, typography } from "styled-system";

export const GridCol = styled.div`
  ${flexbox};
  ${position};
  ${typography};

  display: inline-grid;

  ${({ mobile }) =>
    mobile
      ? `grid-column: auto / span ${mobile};
    -ms-grid-column: ${mobile};`
      : "display: none"};

  @media ${"only screen and (min-width: 768px)"} {
    ${({ tablet }) =>
      tablet
        ? `grid-column: auto / span ${tablet};
        -ms-grid-column: ${tablet};`
        : "display:none"};
    ${({ tablet, mobile }) => tablet && !mobile && "display: inline-grid"}
  }

  @media ${"only screen and (min-width: 1024px)"} {
    ${({ desktop }) =>
      desktop
        ? `grid-column: auto / span ${desktop};
      -ms-grid-column: ${desktop};
      `
        : "display:none"};
    ${({ desktop, tablet }) => desktop && !tablet && "display: inline-grid"}
  }
`;
